import React, { useState, useEffect } from 'react';
import { updatesService } from '../services/updatesService';
import UpdatesModal from './UpdatesModal';

interface UpdatesModalGateProps {
  children: React.ReactNode;
}

const UpdatesModalGate: React.FC<UpdatesModalGateProps> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [showUpdates, setShowUpdates] = useState(false);
  const [version, setVersion] = useState('');
  const [content, setContent] = useState('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const status = await updatesService.getStatus();
        if (!cancelled && status.showUpdates) {
          setShowUpdates(true);
          setVersion(status.version);
          setContent(status.content);
        }
        setError(null);
      } catch (e: any) {
        if (!cancelled) setError(e?.message || 'Failed to load updates');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const handleDismiss = () => {
    setShowUpdates(false);
  };

  if (loading) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      {showUpdates && !error && (
        <UpdatesModal
          version={version}
          content={content}
          onDismiss={handleDismiss}
        />
      )}
    </>
  );
};

export default UpdatesModalGate;
